export type ChatOption = {
  label: string
  value: string
  score?: number
  nextStep?: string
}

export type SectorContent = {
  insight: string
  cards: { title: string; description: string }[]
}

export const SECTORS: Record<string, SectorContent> = {
  'Logística e Distribuição': {
    insight:
      'No setor da Logística, a falta de visibilidade em tempo real é o maior inimigo da margem.',
    cards: [
      {
        title: 'Rastreamento de Frota',
        description: 'Saiba onde está cada veículo em tempo real.',
      },
      {
        title: 'Otimização de Rotas',
        description: 'Reduza custos de combustível e tempo de entrega.',
      },
      {
        title: 'Gestão de Armazém',
        description: 'Automatize entradas e saídas de stock.',
      },
    ],
  },
  'Retalho e E-commerce': {
    insight:
      'Para o Retalho, a sincronização de stock e a previsão de vendas são essenciais para escalar.',
    cards: [
      {
        title: 'Stock Unificado',
        description: 'Sincronize loja física e online automaticamente.',
      },
      {
        title: 'Previsão de Procura',
        description: 'Evite roturas de stock com IA.',
      },
      {
        title: 'Gestão de Encomendas',
        description: 'Centralize pedidos de todos os canais.',
      },
    ],
  },
  'Serviços e Consultoria': {
    insight:
      'Em Serviços, cada hora não faturada é receita perdida. A automação liberta a equipa para o cliente.',
    cards: [
      {
        title: 'Gestão de Projetos',
        description: 'Controlo de horas e rentabilidade por projeto.',
      },
      {
        title: 'Relatórios Automáticos',
        description: 'Gere relatórios de cliente em segundos.',
      },
      {
        title: 'Portal do Cliente',
        description: 'Partilha de documentos e status em self-service.',
      },
    ],
  },
  'Indústria e Produção': {
    insight:
      'Na Indústria, a manutenção preditiva e o controlo de produção (OEE) são os grandes ganhos da IA.',
    cards: [
      {
        title: 'Monitorização OEE',
        description: 'Meça a eficiência das máquinas em tempo real.',
      },
      {
        title: 'Manutenção Preditiva',
        description: 'Antecipe avarias antes que parem a produção.',
      },
      {
        title: 'Gestão de Ordens',
        description: 'Digitalize as ordens de fabrico e turnos.',
      },
    ],
  },
  Imobiliário: {
    insight:
      'No Imobiliário, a velocidade de resposta ao lead define quem fecha o negócio.',
    cards: [
      {
        title: 'CRM Imobiliário',
        description: 'Gestão de leads e follow-up automático.',
      },
      {
        title: 'Matching Automático',
        description: 'Cruze imóveis com o perfil do cliente.',
      },
      {
        title: 'Contratos Digitais',
        description: 'Geração automática de CPCV e propostas.',
      },
    ],
  },
  'Recursos Humanos': {
    insight:
      'Nos RH, a triagem e o onboarding consomem tempo valioso que devia ser para as pessoas.',
    cards: [
      {
        title: 'ATS Inteligente',
        description: 'Triagem automática de currículos com IA.',
      },
      {
        title: 'Onboarding Digital',
        description: 'Processo de integração 100% digital.',
      },
      {
        title: 'Portal do Colaborador',
        description: 'Gestão de férias e ausências self-service.',
      },
    ],
  },
  Outro: {
    insight:
      'Independentemente do setor, a eficiência operacional é a chave para o crescimento sustentável.',
    cards: [
      {
        title: 'Automatização de Processos',
        description: 'Elimine tarefas manuais e repetitivas.',
      },
      {
        title: 'Dashboards de Gestão',
        description: 'Tenha visibilidade total sobre o negócio.',
      },
      {
        title: 'Integração de Sistemas',
        description: 'Faça os seus softwares falarem entre si.',
      },
    ],
  },
}

export const KEYWORD_MAPPING: Record<string, string> = {
  armazém: 'Logística e Distribuição',
  stock: 'Logística e Distribuição',
  entrega: 'Logística e Distribuição',
  frota: 'Logística e Distribuição',
  loja: 'Retalho e E-commerce',
  venda: 'Retalho e E-commerce',
  online: 'Retalho e E-commerce',
  shopify: 'Retalho e E-commerce',
  consultoria: 'Serviços e Consultoria',
  projeto: 'Serviços e Consultoria',
  cliente: 'Serviços e Consultoria',
  fábrica: 'Indústria e Produção',
  produção: 'Indústria e Produção',
  máquina: 'Indústria e Produção',
  imóvel: 'Imobiliário',
  visita: 'Imobiliário',
  contrato: 'Imobiliário',
  agência: 'Imobiliário',
  candidato: 'Recursos Humanos',
  entrevista: 'Recursos Humanos',
  salário: 'Recursos Humanos',
  equipa: 'Recursos Humanos',
}
